import { FormFields } from 'app/modules/filingFormGenerator/models';
import { adaptLegacySchema } from 'app/modules/goAML/formConfig/schemaAdapter';
import { GoamlReferenceTables } from 'app/modules/goAML/queries/useGetGoamlFiuConfig';
import {
  T_PERSON_REGISTRATION_CORE_FIELDS,
  T_PERSON_REGISTRATION_OPTIONAL_FIELDS,
} from 'app/modules/goAML/schemas/tPersonRegistrationSchema';

export const getReportingPersonFormFields = (
  referenceTables: GoamlReferenceTables,
): FormFields<Record<string, any>> => [
  ...adaptLegacySchema(T_PERSON_REGISTRATION_CORE_FIELDS, referenceTables),
  {
    type: 'section',
    name: 'additional_details',
    label: 'Additional details',
    collapsible: true,
    defaultCollapsed: true,
    bindFieldsToParentPath: true,
    mustExistInPayload: false,
    mustHaveValueIfExist: false,
    fields: adaptLegacySchema(
      T_PERSON_REGISTRATION_OPTIONAL_FIELDS,
      referenceTables,
    ),
  },
];
